import { render, staticRenderFns } from "./RfiPageSelect.vue?vue&type=template&id=06dbb41f&scoped=true&"
import script from "./RfiPageSelect.vue?vue&type=script&lang=js&"
export * from "./RfiPageSelect.vue?vue&type=script&lang=js&"
import style0 from "./RfiPageSelect.vue?vue&type=style&index=0&id=06dbb41f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dbb41f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06dbb41f')) {
      api.createRecord('06dbb41f', component.options)
    } else {
      api.reload('06dbb41f', component.options)
    }
    module.hot.accept("./RfiPageSelect.vue?vue&type=template&id=06dbb41f&scoped=true&", function () {
      api.rerender('06dbb41f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/templates/RfiPageSelect.vue"
export default component.exports